var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C4.97656 0 0.5 4.47656 0.5 10C0.5 15.5234 4.97656 20 10.5 20C16.0234 20 20.5 15.5234 20.5 10C20.5 4.47656 16.0234 0 10.5 0ZM10.5 18.75C5.67578 18.75 1.75 14.8242 1.75 10C1.75 5.17578 5.67578 1.25 10.5 1.25C15.3242 1.25 19.25 5.17578 19.25 10C19.25 14.8242 15.3242 18.75 10.5 18.75ZM10.5 11.875C10.8455 11.875 11.125 11.5955 11.125 11.25V5C11.125 4.65453 10.8455 4.375 10.5 4.375C10.1545 4.375 9.875 4.65625 9.875 5V11.25C9.875 11.5938 10.1562 11.875 10.5 11.875ZM10.5 13.4375C9.98242 13.4375 9.5625 13.8574 9.5625 14.375C9.5625 14.8926 9.98242 15.3125 10.5 15.3125C11.0176 15.3125 11.4375 14.8926 11.4375 14.375C11.4375 13.8574 11.0195 13.4375 10.5 13.4375Z",
    fill: "#CD4E5D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.1ed7adebbd203007648cc224f3e1e958.svg";
export { ForwardRef as ReactComponent };